import React from "react";
import {Alert, Button, Paper} from "@mui/material";
import {styled} from "@mui/material/styles";
import StyledContainer from "./_common/StyledContainer";
import StyledHeader from "./_common/StyledHeader";
import StyledSubheader from "./_common/StyledSubheader";
import {
  clearStoredAuthLoginErrorMessage,
  getStoredAuthLoginErrorMessage,
} from "../utils/authLoginError";
import {redirectToSuiteManagerLogout} from "../utils/suiteManagerAuth";

const StyledCard = styled(Paper)(({theme}) => ({
  maxWidth: 720,
  width: "100%",
  padding: theme.spacing(4),
}));

const StyledButton = styled(Button)(({theme}) => ({
  marginTop: theme.spacing(3),
}));

const AuthLoginError = () => {
  const errorMessage = getStoredAuthLoginErrorMessage();

  const handleBackToLogin = () => {
    clearStoredAuthLoginErrorMessage();
    redirectToSuiteManagerLogout();
  };

  return (
    <StyledContainer maxWidth="md" style={{height:'60%'}}>
      <StyledCard elevation={3}>
        <StyledHeader color="info">
          Oops!
        </StyledHeader>
        <StyledSubheader>
          We hit an error while signing you in.
        </StyledSubheader>
        <Alert severity="error" variant="outlined">
          {errorMessage}
        </Alert>
        <StyledButton
          variant="contained"
          color="primary"
          onClick={handleBackToLogin}
        >
          Back to login
        </StyledButton>
      </StyledCard>
    </StyledContainer>
  );
};

export default AuthLoginError;
